import { ITransferPendingCoursesDatasource } from './../datasources/transfer_pending_courses_datasource';
import { ITransferCollegesDatasource } from './../datasources/transfer_colleges_datasource';
import { Course } from './../builders/course_builder';
import { College } from './../builders/college_builder';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { IQueryMediator, IQuery } from 'core-ts-types';

export interface ITransferCollegeWithCourses {
  college: College;
  courses: Course[];
}

export class TransferCollegesWithCoursesQuery implements IQuery {
  private _result: ITransferCollegeWithCourses[];

  constructor(
    QueryMediator: IQueryMediator,
    private ngTransferCollegesDatasource: ITransferCollegesDatasource,
    private ngTransferCoursesDatasource: ITransferCoursesDatasource,
    private ngTransferPendingCoursesDatasource: ITransferPendingCoursesDatasource
  ) {
    QueryMediator.registerQuery(
      this,
      ngTransferCollegesDatasource,
      ngTransferCoursesDatasource,
      ngTransferPendingCoursesDatasource
    );
  }

  run(): TransferCollegesWithCoursesQuery {
    const articulated_courses = _.values<Course>(this.ngTransferCoursesDatasource.read());
    const pending_courses = _.values<Course>(this.ngTransferPendingCoursesDatasource.read());
    const all_courses = articulated_courses.concat(pending_courses);
    const colleges = _.sortBy(this.ngTransferCollegesDatasource.read(), (college) => college.created_ts).reverse();

    this._result = _.map(colleges, (college) => {
      return {
        college: college,
        courses: _(all_courses)
          .filter((course) => course.college_nk === college.nk)
          .sortBy('created_ts')
          .value()
          .reverse()
      };
    });

    return this;
  }

  get result(): ITransferCollegeWithCourses[] {
    return this._result;
  }
}

angular
  .module('capability-ng-transfer')
  .service('ngTransferCollegesWithCoursesQuery', TransferCollegesWithCoursesQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_colleges_with_courses_query.ts